import { ReactElement, FC, ReactNode, useEffect, useCallback, createRef } from 'react'

import { ModalCardProps } from '../../types'

import './modalCard.css'

const ModalCard: FC<ReactNode & ModalCardProps> = (props): ReactElement => {
  const { children, onClose, modalClassName } = props

  const modalFocusRef = createRef<HTMLDivElement>()

  const elementFocus = useCallback(
    (e): void => {
      if (e.key === 'Tab') {
        if (modalFocusRef && modalFocusRef.current) {
          const focusableModalElements = modalFocusRef.current?.querySelectorAll(
            'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
          )

          const firstElement = focusableModalElements[0] as HTMLElement
          const lastElement = focusableModalElements[focusableModalElements.length - 1] as HTMLElement

          if (!e.shiftKey && document.activeElement !== firstElement) {
            firstElement.focus()
            return e.preventDefault()
          }

          if (e.shiftKey && document.activeElement !== lastElement) {
            lastElement.focus()
            return e.preventDefault()
          }
        }
      }
    },
    [modalFocusRef]
  )

  useEffect(() => {
    document.addEventListener('keydown', elementFocus, { once: true })
    return () => document.removeEventListener('keydown', elementFocus)
  }, [elementFocus])

  return (
    <div className={`modal-card-elements ${modalClassName}`} id="modal-elements" ref={modalFocusRef}>
      <button name="close-modal" className="modal-card-close-btn btn-wrapper" id="close-modal-btn" onClick={() => onClose()}>
        <i className="feather-x"></i>
      </button>
      <div className="modal-card-content">{children}</div>
    </div>
  )
}

export default ModalCard
